import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  BookingServicesQueryParams,
  BookingServicesResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const BOOKING_SERVICES_LIST_QUERY_KEY = 'booking_services_list';

export const useBookingServicesListQuery = (
  url: string,
  queryParams: BookingServicesQueryParams,
) =>
  useQuery({
    queryKey: [BOOKING_SERVICES_LIST_QUERY_KEY, url, queryParams],
    queryFn: () =>
      HttpClient.request<BookingServicesResponseData>({
        method: 'GET',
        url,
        params: queryParams,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
